import { render, staticRenderFns } from "./SoftSalesActivity.vue?vue&type=template&id=34c697ea"
import script from "./SoftSalesActivity.vue?vue&type=script&lang=js"
export * from "./SoftSalesActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34c697ea')) {
      api.createRecord('34c697ea', component.options)
    } else {
      api.reload('34c697ea', component.options)
    }
    module.hot.accept("./SoftSalesActivity.vue?vue&type=template&id=34c697ea", function () {
      api.rerender('34c697ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/SoftSalesActivity.vue"
export default component.exports